import styled from 'styled-components'

export const Root = styled.div`
  text-align: center;
  width: 80%;
  margin: 24px auto;
`
export const Header = styled.p`
  color: #FFF176;
  font-family: 'Nixie One', cursive;
  font-size: 24px;
  margin-bottom: 32px;
`
export const TechItemsContainer = styled.div`
  box-sizing: border-box;
`

export const TechItemContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: 48px;
`
export const Image = styled.img`
  margin: 0 4px 4px 4px;
`
